import { IGetMobileAnnouncementDraftResponse } from '../../../repositories/announcements/v1/get-mobile-announcement-draft';
import { IOfferDraftState, TGetOfferDraftResult } from '../types';

export const mapResponse200 = (response: IGetMobileAnnouncementDraftResponse): TGetOfferDraftResult => {
  /** TODO: нужен маппинг данных */
  return (response.offer as unknown as IOfferDraftState) || null;
};
